const mobileMenuOverlay = document.querySelector('.mobile-menu__overlay');
const openMobileMenuButton = document.querySelector('.open-mobile-menu');
const mainHeader = document.querySelector('.main-header');

if (mobileMenuOverlay && openMobileMenuButton) {
  let isOpen = false;

  mobileMenuOverlay.style.opacity = '0';
  mobileMenuOverlay.style.pointerEvents = 'none';
  mobileMenuOverlay.style.transition = 'opacity 250ms ease';

  openMobileMenuButton.addEventListener('click', () => {
    isOpen = !isOpen;
    mobileMenuOverlay.style.opacity = isOpen ? '1' : '0';
    mobileMenuOverlay.style.pointerEvents = isOpen ? 'auto' : 'none';
    if (mainHeader) {
      mainHeader.classList.toggle('active', isOpen);
    }
  });
}
